import { baseTheme } from "./base";
export const defaultTheme = Object.assign({}, baseTheme);
